/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_Name_HelpInputs */

const en_team_manager_group_name_help = /** @type {(inputs: Team_Manager_Group_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a name for this group`)
};

const fr_team_manager_group_name_help = /** @type {(inputs: Team_Manager_Group_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez un nom pour ce groupe`)
};

const de_team_manager_group_name_help = /** @type {(inputs: Team_Manager_Group_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie einen Namen für diese Gruppe ein.`)
};

const it_team_manager_group_name_help = /** @type {(inputs: Team_Manager_Group_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un nome per questo gruppo`)
};

const ru_team_manager_group_name_help = /** @type {(inputs: Team_Manager_Group_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите название для этой группы.`)
};

const es_team_manager_group_name_help = /** @type {(inputs: Team_Manager_Group_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca un nombre para este grupo`)
};

const zh_cn2_team_manager_group_name_help = /** @type {(inputs: Team_Manager_Group_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入该组的名称`)
};

const ja_team_manager_group_name_help = /** @type {(inputs: Team_Manager_Group_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このグループの名前を入力してください`)
};

const hi_team_manager_group_name_help = /** @type {(inputs: Team_Manager_Group_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस समूह के लिए एक नाम दर्ज करें`)
};

const pt_pt2_team_manager_group_name_help = /** @type {(inputs: Team_Manager_Group_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira um nome para este grupo.`)
};

/**
* | output |
* | --- |
* | "Enter a name for this group" |
*
* @param {Team_Manager_Group_Name_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_name_help = /** @type {((inputs?: Team_Manager_Group_Name_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_Name_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_group_name_help(inputs)
	if (locale === "de") return de_team_manager_group_name_help(inputs)
	if (locale === "it") return it_team_manager_group_name_help(inputs)
	if (locale === "ru") return ru_team_manager_group_name_help(inputs)
	if (locale === "es") return es_team_manager_group_name_help(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_group_name_help(inputs)
	if (locale === "ja") return ja_team_manager_group_name_help(inputs)
	if (locale === "hi") return hi_team_manager_group_name_help(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_group_name_help(inputs)
	return en_team_manager_group_name_help(inputs)
});